import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const CashAppBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.CASH_APP}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.CASH_APP)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.CASH_APP)} alt="cash-app" />
    </Box>
  );
};
